import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys, type StatisticPeriod } from '../api/dashboard.api';

export function useMDPlSummary(period: StatisticPeriod) {
  return useQuery({
    queryKey: dashboardQueryKeys.mdPlSummary(period),
    queryFn: () => dashboardApi.getMDPlSummary(period),
  });
}
